@if (!isLookBook) { @for (articleMedia of articleMedias; track articleMedia) {
<atx-media-preview
  [media]="articleMedia"
  [activateMedia]="activateMedia"
  [maxWidth]="imageSizes.XXXSMALL"
  objectFit="cover"
  [startVideoAdvancedBy]="3"
  atxVisible
  [threshold]="1"
  [visibleEnabled]="isSmall"
  (visible)="setActivateMedia($event)"
  [showPreviewMedia]="true"
  [videoAttributes]="videoAttributes"
>
</atx-media-preview>
}
<epc-spotlight-item-header
  [title]="article?.references[0].name"
  [active]="isActive"
></epc-spotlight-item-header>
} @else { @if (article?.referenceId) {
<epc-lookbook-spotlight-item
  [defaultCollapsed]="article?.isCollapsed"
  [article]="article"
  [referenceIds]="referenceIds"
  (referenceClicked)="trackList($event)"
  (collapsed)="isLookBookCollapsed$$.next($event)"
></epc-lookbook-spotlight-item>
} }

<epc-feed-article-overlay
  [isLookbook]="isLookBook"
  [isVideo]="isVideo"
  [hasPowerList]="hasPowerList"
  [showPins]="showPins$ | async"
  [showBin]="showBin$ | async"
  [referenceId]="article?.referenceId"
  [referenceIds]="referenceIds"
  [isDirectShow]="isDirectShow"
  [isPinned]="!article.isPinned"
  [isActive]="isActive"
  [isShowIndicator]="isShowIndicator$ | async"
  [visiblePins]="showPinsWithHover$$ | async"
  [hasCommercialList]="hasCommercialList"
  (togglePinState)="togglePinState($event)"
  (clicked)="onArticleClick($event)"
  (delete)="delete.emit()"
>
  <ng-container badges>
    <ng-content select="[badges]"></ng-content>
  </ng-container>
</epc-feed-article-overlay>
